import React, { Component } from 'react';
import Section from './layouts/Section';
import { Link } from 'react-router-dom';
import PageLayout from './layouts/PageLayout';
class BlogDetails2 extends Component {
  render() {
    return (
            <PageLayout title="Cell Station – Blog Details | Expert Cellphone Repair">
      <Section title={'Blog Details'}>
        <section className='section page-content'>
          <div className='container'>
            <div className='row justify-content-center'>
              <div className='col-lg-8'>
                <img
                  className='img-fluid'
                  src={process.env.PUBLIC_URL + '/assets/images/blogs/details/03.jpg'}
                  alt='' loading="lazy"
                />
                <div className='blog-meta h6 mt-15'>
                  <span className='font-w-600 mr-3'>
                    <span className='fas fa-calendar-alt text-primary mr-2' />
                    21-May-2020
                  </span>
                  <span className='font-w-600'>
                    <span className='fas fa-comment-dots text-primary mr-2' />
                    Comment
                  </span>
                </div>
                <h3 className='text-dark mt-10 mb-25'> Can you still use an iPhone with a cracked screen?</h3>
                <p className='mt-15'>
                  Absolutely, you can still use an iPhone with a cracked screen, but it depends on the severity of the
                  damage. If it’s a minor crack that doesn’t affect the touch functionality or display, you might be
                  able to continue using it for a while. However, using a cracked screen can lead to further problems.
                  Over time, the crack can spread, making it harder to see your screen or use certain features. It may
                  also allow dust and moisture to enter the device, potentially damaging internal components. Moreover,
                  cracked screens can cause finger injuries due to sharp edges. In some cases, the touch sensitivity or
                  Face ID might stop working properly. Although it might seem fine initially, even small cracks can
                  weaken the phone’s structure. If you’re planning to trade in or sell your iPhone in the future, a
                  cracked screen can significantly reduce its value.
                </p>
                <p className='mt-15'>
                  Repairing it sooner rather than later can save you money in the long run. Plus, you’ll enjoy a
                  smoother, safer user experience. We always recommend getting it checked by a professional. At our
                  store, we offer quick and affordable screen repair services. Don’t wait until the damage gets
                  worse—bring it in today and let us help!
                </p>
                {/* <p className='mt-15'>
                  In no impression assistance contrasted. Manners she wishing justice hastily new anxious. At discovery
                  discourse departure objection we. Few extensive add delighted tolerably sincerity her. Law ought him
                  least enjoy decay one quick court. Expect warmly its tended garden him esteem had remove off. Effects
                  dearest staying now sixteen nor improve.{' '}
                </p> */}

                <blockquote className='text-center bg-light-gray pt-40 pb-40 border my-4'>
                  <div className='row justify-content-center'>
                    <div className='col-md-10'>
                      <p className='quote-text text-dark font-w-600'>
                        Using your phone with a cracked screen can do more harm than good. The damage can spread, affect
                        touch response, or even injure your fingers. Don’t wait for it to get worse—bring it to us for a
                        fast, reliable repair. We’ll have your screen looking brand new in no time, so you can get back
                        to using your phone safely and smoothly!
                      </p>
                      <div className='quote-info'>
                        <h5 className='mt-25 text-dark'>Cell Station </h5>
                        <small className='text-uppercase text-primary font-w-600'>Cell Phone Repair & more</small>
                      </div>
                    </div>
                  </div>
                </blockquote>

                <p>
                  Rest assured, repairing your phone screen will not affect its performance or slow it down. We use
                  high-quality parts and expert techniques to ensure your device works just as smoothly as before—just
                  with a flawless new screen. Everything from your apps to your battery life will function exactly the
                  same, if not better!
                </p>
                {/* <p className='mt-15'>
                  Any delicate you how kindness horrible outlived servants. You high bed wish help call draw side. Girl
                  quit if case mr sing as no have. At none neat am do over will. Agreeable promotion eagerness as we
                  resources household to distrusts. Polite do object at passed it is. Small for ask shade water manor
                  think men begin.{' '}
                </p> */}

                {/* <div className='comments mt-70'>
                  <h3 className='text-dark mb-25'>Comment</h3>
                  <div className='media d-block d-sm-flex'>
                    <img src='assets/images/blogs/details/user.jpg' className='mr-25' alt='' loading="lazy" />
                    <div className='media-body mt-3 mt-sm-0'>
                      <h5 className='font-w-600 text-dark d-inline'>Eileen Finnen</h5>
                      <span className='font-w-400 ml-2 d-inline'>21 - May - 2020</span>
                      <p className='mt-3'>
                        You high bed wish help call draw side. Girl quit if case mr sing as no have. At none neat am do
                        over will. Agreeable promotion eagerness.
                      </p>
                    </div>
                  </div>
                </div> */}

                {/* <div className='comments-form mt-70'>
                  <h3 className='text-dark mb-25'>Add Comment</h3>
                  <form method='POST'>
                    <div className='row'>
                      <div className='form-group mb-30 col-md-4'>
                        <input
                          className='form-control shadow-none rounded-0 py-4 px-3'
                          type='text'
                          placeholder='Name'
                          required=''
                        />
                      </div>
                      <div className='form-group mb-30 col-md-4'>
                        <input
                          className='form-control shadow-none rounded-0 py-4 px-3'
                          type='email'
                          placeholder='Email'
                          required=''
                        />
                      </div>
                      <div className='form-group mb-30 col-md-4'>
                        <input
                          className='form-control shadow-none rounded-0 py-4 px-3'
                          type='url'
                          placeholder='Website'
                        />
                      </div>
                      <div className='form-group mb-30 col-md-12'>
                        <textarea
                          className='form-control shadow-none rounded-0 p-3'
                          name='comment'
                          required=''
                          rows='4'
                        />
                      </div>
                    </div>
                    <button className='btn btn-sm btn-primary' type='submit'>
                      Post Comment{' '}
                    </button>
                  </form>
                </div> */}
              </div>

              <div className='col-lg-4 mt-5 mt-lg-0'>
                <div className='widget widget-search mt-0'>
                  <form className='d-flex'>
                    <input
                      type='search'
                      className='form-control border-0 shadow-none bg-transparent'
                      placeholder='Search'
                    />
                    <button type='submit' className='border-0 bg-transparent'>
                      <span className='fas fa-search' />
                    </button>
                  </form>
                </div>
                <div className='widget widget-categoty'>
                  <div className='widget-heading'>Categoty</div>
                  <ul className='category-list list-unstyled p-4'>
                    <li>
                      <span className='fas fa-caret-right mr-2' />
                      <Link to={'/services'} className='text-reset initiate-scripts'>
                        PC Laptop Repair
                      </Link>
                    </li>
                    <li>
                      <span className='fas fa-caret-right mr-2 mt-3' />
                      <Link to={'/services'} className='text-reset initiate-scripts'>
                        Mac Repair
                      </Link>
                    </li>
                    <li>
                      <span className='fas fa-caret-right mr-2 mt-3' />
                      <Link to={'/services'} className='text-reset initiate-scripts'>
                        PC Desktop Repair
                      </Link>
                    </li>
                    <li>
                      <span className='fas fa-caret-right mr-2 mt-3' />
                      <Link to={'/services'} className='text-reset initiate-scripts'>
                        iPhone Repair
                      </Link>
                    </li>
                    <li>
                      <span className='fas fa-caret-right mr-2 mt-3' />
                      <Link to={'/services'} className='text-reset initiate-scripts'>
                        iPad Repair
                      </Link>
                    </li>
                    <li>
                      <span className='fas fa-caret-right mr-2 mt-3' />
                      <Link to={'/services'} className='text-reset initiate-scripts'>
                        Smartphone Repair
                      </Link>
                    </li>
                  </ul>
                </div>
                {/* <div className='widget widget-categoty'>
                  <div className='widget-heading'>Latest Post</div>
                  <div className='p-3'>
                    <div className='media d-block d-sm-flex mt-15'>
                      <Link to={'/blog'} className='pt-2 initiate-script'>
                        <img src={process.env.PUBLIC_URL + '/assets/images/blogs/01-sm.jpg'} className='mr-15' alt='' loading="lazy" />
                      </Link>
                      <div className='media-body mt-3 mt-sm-0'>
                        <Link to={'/blog-details'} className='font-w-600 text-dark d-block initiate-scripts'>
                          Barton Did Feebly Change Man She Afford Square
                        </Link>
                        <span className='font-w-600 mr-3 small'>
                          <span className='fas fa-calendar-alt text-primary mr-2' />
                          21-May-2020
                        </span>
                      </div>
                    </div>
                    <div className='media d-block d-sm-flex mt-20'>
                      <Link to={'/blog'} className='pt-2 initiate-script'>
                        <img src={process.env.PUBLIC_URL + '/assets/images/blogs/03-sm.jpg'} className='mr-15' alt='' loading="lazy" />
                      </Link>
                      <div className='media-body mt-3 mt-sm-0'>
                        <Link to={'/blog-details'} className='font-w-600 text-dark d-block initiate-scripts'>
                          Barton Did Feebly Change Man She Afford Square
                        </Link>
                        <span className='font-w-600 mr-3 small'>
                          <span className='fas fa-calendar-alt text-primary mr-2' />
                          21-May-2020
                        </span>
                      </div>
                    </div>
                    <div className='media d-block d-sm-flex mt-20'>
                      <Link to={'/blog'} className='pt-2 initiate-script'>
                        <img src={process.env.PUBLIC_URL + '/assets/images/blogs/02-sm.jpg'} className='mr-15' alt='' loading="lazy" />
                      </Link>
                      <div className='media-body mt-3 mt-sm-0'>
                        <Link to={'/blog-details'} className='font-w-600 text-dark d-block initiate-scripts'>
                          Barton Did Feebly Change Man She Afford Square
                        </Link>
                        <span className='font-w-600 mr-3 small'>
                          <span className='fas fa-calendar-alt text-primary mr-2' />
                          21-May-2020
                        </span>
                      </div>
                    </div>
                  </div>
                </div> */}
                {/* <div className='widget widget-categoty'>
                  <div className='widget-heading'>Archives</div>
                  <ul className='category-list list-unstyled p-4'>
                    <li>
                      <span className='fas fa-caret-right mr-2' />
                      <Link to={'/blog'} className='text-reset initiate-scripts'>
                        April
                      </Link>
                    </li>
                    <li>
                      <span className='fas fa-caret-right mr-2 mt-3' />
                      <Link to={'/blog'} className='text-reset initiate-scripts'>
                        May
                      </Link>
                    </li>
                    <li>
                      <span className='fas fa-caret-right mr-2 mt-3' />
                      <Link to={'/blog'} className='text-reset initiate-scripts'>
                        June
                      </Link>
                    </li>
                    <li>
                      <span className='fas fa-caret-right mr-2 mt-3' />
                      <Link to={'/blog'} className='text-reset initiate-scripts'>
                        July
                      </Link>
                    </li>
                    <li>
                      <span className='fas fa-caret-right mr-2 mt-3' />
                      <Link to={'/blog'} className='text-reset initiate-scripts'>
                        August
                      </Link>
                    </li>
                    <li>
                      <span className='fas fa-caret-right mr-2 mt-3' />
                      <Link to={'/blog'} className='text-reset initiate-scripts'>
                        September
                      </Link>
                    </li>
                  </ul>
                </div> */}
                <div className='widget widget-categoty'>
                  <div className='widget-heading'>Tag</div>
                  <ul className='category-list list-unstyled list-inline p-3 text-center'>
                    <li className='list-inline-item'>
                      <Link to={'/blog'} className='text-reset p-1 initiate-scripts'>
                        Cmputer repair
                      </Link>
                    </li>
                    <li className='list-inline-item'>
                      <Link to={'/blog'} className='text-reset p-1 initiate-scripts'>
                        Desktop computer
                      </Link>
                    </li>
                    <li className='list-inline-item'>
                      <Link to={'/blog'} className='text-reset p-1 initiate-scripts'>
                        Electric
                      </Link>
                    </li>
                    <li className='list-inline-item'>
                      <Link to={'/blog'} className='text-reset p-1 initiate-scripts'>
                        Pc repair
                      </Link>
                    </li>
                    <li className='list-inline-item'>
                      <Link to={'/blog'} className='text-reset p-1 initiate-scripts'>
                        Home appliance
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </section>
      </Section>
      </PageLayout>
    );
  }
}

export default BlogDetails2;
